import Script from 'next/script'
import { useOttOverlay, useWindow } from '../../contexts'
import { isBrowser } from '../../client'
import { usePlayerStore } from '../../store'
import { config } from '../../lib'

type ScriptsProps = {
  isEmbedPlayer?: boolean
}

export const Scripts = ({ isEmbedPlayer }: ScriptsProps) => {
  const { setKalturaLoaded, kalturaLoaded } = useOttOverlay()
  const [setGooglePalReady] = usePlayerStore(state => [state.setGooglePalReady])
  const win = useWindow()

  if (!config) {
    return null
  }

  return (
    <>
      {/*{config.params.PlayerSettings.SCRIPT_URL && (*/}
      {/*  <Script*/}
      {/*    key={'ott_player'}*/}
      {/*    id={'ott_player'}*/}
      {/*    src={config.params.PlayerSettings.SCRIPT_URL}*/}
      {/*    onLoad={() => setKalturaLoaded({ ...kalturaLoaded, opc: true })}*/}
      {/*  />*/}
      {/*)}*/}
      {config.plugins?.minute_ly && (
        <Script
          key={'minute.ly'}
          strategy={'beforeInteractive'}
          src={'//apv-launcher.minute.ly/api/launcher/MIN-20600.js'}
          async
        />
      )}
      <Script
        key={'KalturaPlayer'}
        strategy={'beforeInteractive'}
        src={
          'https://cdnapisec.kaltura.com/p/2748741/embedPlaykitJs/uiconf_id/' +
          config.uiconf_id
        }
        onReady={() => setKalturaLoaded({ ...kalturaLoaded, kmc: true })}
      />
      <Script
        key={'GooglePal'}
        strategy={'afterInteractive'}
        src={'https://imasdk.googleapis.com/pal/sdkloader/pal.js'}
        onReady={() => setGooglePalReady(true)}
        onError={() => setGooglePalReady('error')}
      />
      {/*<TaboolaLoader key={'TaboolaLoader'} />*/}
      {!isEmbedPlayer && win && isBrowser() ? (
        <Script
          key={'accessibility'}
          strategy={'afterInteractive'}
          src={'/cdn/accessibility/accessibility_source.js'}
          id={'accessibilityIncSource'}
          data-username={'iav2b023'}
          data-version={'5'}
          data-source='package'
          data-language={'he'}
        />
      ) : null}
    </>
  )
}
